export default __webpack_public_path__ + "static/media/mail.fcc14ece.svg";